import axios from "axios";
import { baseURL } from "config";
import { convertKeysToCamelCase } from "utils/caseConvertor";
async function getBrandDetailByUrl(url: any) {
  const res = await axios.get(`${baseURL}/admin/brand-detail/${url}`);
  const data = convertKeysToCamelCase(res.data);
  return data;
}
export default getBrandDetailByUrl;
